import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Update } from "../../App";
import { Stack } from "@mui/material";
import GymCard from "../../components/GymCard";
import { ChallengeC } from "../../components/FitFinderInfo";
import { BeginnerC } from "../../components/FitFinderInfo";
import { IntermediateC } from "../../components/FitFinderInfo";
import { AdvanceC } from "../../components/FitFinderInfo";
import { UserC } from "../../components/FitFinderInfo";
import Cookies from "js-cookie";

const Discover = () => {
  const { setDisplayAppBar,mode } = useContext(Update);
  const location = useLocation();
  const beginnerc = new BeginnerC();
  const intermediatec = new IntermediateC();
  const advancec = new AdvanceC();
  const challengec = new ChallengeC();
  const userc = new UserC();
  const [challenge, setChallenge] = useState([]);
  const [Beginner, setBeginner] = useState([]);
  const [Intermediate, setIntermediate] = useState([]);
  const [Advance, setAdvance] = useState([]);
  const [data1, setData] = useState(0);
  let data;

  useEffect(() => {
    if (location.pathname === "/gym/discovergym") {
      setDisplayAppBar("none");
    }
    async function storeData() {
      try {
        let hash=Cookies.get("_hash")
        data = await userc.getDocData(hash);
        setData(data.data());
      } catch (err) {
        console.log(err);
      }
    }
    storeData();
    async function getData1() {
      try {
        const c = await challengec.getDocsData();
        setChallenge(c.docs);
      } catch (error) {
        console.log("error");
      }
    }

    async function getData2() {
      try {
        const b = await beginnerc.getDocsData();
        setBeginner(b.docs);
      } catch (err) {
        console.log("error");
      }
    }
    async function getData3() {
      try {
        const i = await intermediatec.getDocsData();
        setIntermediate(i.docs);
      } catch (err) {
        console.log("error");
      }
    }
    async function getData4() {
      try {
        const a = await advancec.getDocsData();
        setAdvance(a.docs);
      } catch (err) {
        console.log("error");
      }
    }
    
    getData1();
    getData2();
    getData3();
    getData4();
  }, []);

  return (
    <div>
      <Typography
        sx={{
          margin: {
            sm: "100px 0px 20px 62.286px",
            lg: "100px 0px 20px 260.857px ",
          },
          fontSize: "30px",
          fontWeight: "600",
          color:mode==="light"?('rgba(0, 0, 0, 0.65)'):('white') 
        }}
      >
        7x4 CHALLENGE
      </Typography>
      <Stack
        direction="row"
        sx={{
          margin: {
            sm: "0px 0px 20px 62.286px",
            lg: "0px 0px 20px 260.857px ",
          },
        }}
      >
          {challenge.map((item) => (
          <GymCard Carddetail={item.data()} data1={data1} />
        ))}
      </Stack>
      <Typography
        sx={{
          margin: {
            sm: "100px 0px 20px 62.286px",
            lg: "100px 0px 20px 260.857px ",
          },
          fontSize: "30px",
          fontWeight: "600",
          color:mode==="light"?('rgba(0, 0, 0, 0.65)'):('white') 

        }}
      >
        Beginner
      </Typography>

      <Stack
        direction="row"
        className="DiscoverScrollbar"
        sx={{
          p: "10px 0px",
          ml: { sm: "62.286px", lg: "260.857px" },
          overflowX: "scroll",
        }}
      >
        {Beginner.map((item) => (
          <GymCard Carddetail={item.data()} data1={data1} level={" BEGINNER"}/>
        ))}
      </Stack>
      <Typography
        sx={{
          margin: {
            sm: "100px 0px 20px 62.286px",
            lg: "100px 0px 20px 260.857px ",
          },
          fontSize: "30px",
          fontWeight: "600",
          color:mode==="light"?('rgba(0, 0, 0, 0.65)'):('white') 

        }}
      >
        {" "}
        Intermediate
      </Typography>
      <Stack
        direction="row"
        className="DiscoverScrollbar"
        sx={{
          p: "10px 0px",
          ml: { sm: "62.286px", lg: "260.857px" },
          overflowX: "scroll",
        }}
      >
        {Intermediate.map((item) => (
          <GymCard Carddetail={item.data()} data1={data1} level=" INTERMEDIATE"/>
        ))}
      </Stack>

      <Typography
        sx={{
          margin: {
            sm: "100px 0px 20px 62.286px",
            lg: "100px 0px 20px 260.857px ",
          },
          fontSize: "30px",
          fontWeight: "600",
          color:mode==="light"?('rgba(0, 0, 0, 0.65)'):('white') 

        }}
      >
        {" "}
        Advance
      </Typography>
      <Stack
        direction="row"
        className="DiscoverScrollbar"
        sx={{
          p: "10px 0px",
          ml: { sm: "62.286px", lg: "260.857px" },
          overflowX: "scroll",
        }}
      >
        {Advance.map((item) => (
          <GymCard Carddetail={item.data()} data1={data1} level=" ADVANCE"/>
        ))}
      </Stack>
    </div>
  );
};

export default Discover;
